import { render, staticRenderFns } from "./RLSUnderwriterFollowersChecklist.vue?vue&type=template&id=45f441c2&scoped=true"
import script from "./RLSUnderwriterFollowersChecklist.vue?vue&type=script&lang=js"
export * from "./RLSUnderwriterFollowersChecklist.vue?vue&type=script&lang=js"
import style0 from "./RLSUnderwriterFollowersChecklist.vue?vue&type=style&index=0&id=45f441c2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45f441c2",
  null
  
)

export default component.exports